import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function linkPluginTrigger(evt: PluginEvent, editor: Editor) {
    return (
        evt.eventType === PluginEventType.ContentChanged ||
        evt.eventType === PluginEventType.ExtractContent ||
        evt.eventType === PluginEventType.KeyDown ||
        evt.eventType === PluginEventType.KeyPress
    );
}
